<template>
  <a-drawer :title="title" placement="right" :forceRender="true" :visible="visibles" :destroyOnClose="true"
    :bodyStyle="{ padding: '10px' }" :width="drawerWidth" @close="onClose">
    <a-spin :spinning="copyLoading">
      <div class="container">
        <a-form :form="form" layout="inline">
          <div class="item">
            <a-form-item label="产品名称" layout="inline">
              <a-input
                v-decorator="['productName', { rules: [{ required: true, whitespace: true, message: '产品名称不能为空' }], initialValue: detail.productName }]"
                style="width:250px" placeholder="输入产品名称" />
            </a-form-item>
          </div>
          <a-tabs >
            <a-tab-pane key="0" tab="原料">
              <a-row justify="space-between" type="flex" style="margin-bottom:10px">
                <a-space>
                  <a-button type="primary" @click="toggleAddVisible">添加</a-button>
                  <a-button type="danger" @click="delectItem" :disabled="!selectedRowKeys.length > 0"
                    ghost>删除</a-button>
                  <a-button type="primary" @click="toggleReplaceVisible"
                    :disabled="selectedRowKeys.length !== 1">替换</a-button>
                  <a-button type="primary" @click="openPreviewNutrition" :disabled="preIsDisabled">预览营养需要量</a-button>
                </a-space>
                <a-form-item label="产品盘重" layout="inline">
                  {{ detail.totalWeight }}KG
                  <!-- <a-input style="width:250px" placeholder="设置产品盘重" /> -->
                </a-form-item>
              </a-row>
              <a-table :scroll="{ x: 0, y: 350 }" :columns="rawColumns" :pagination="false"
                :loading="rawLoading" :row-key="record => record.rawId"
                :row-selection="{ selectedRowKeys, onChange: onSelectChange, getCheckboxProps: checkboxProps }"
                :dataSource="raw.formulaRawProductVOList">
                <span slot="uasge" slot-scope="text">
                  {{ text == null || text == '' ? text : text.toFixed(3) }}
                </span>
                <template slot-scope="text, record, index" slot="percentage">
                  <span v-if="index + 1 == raw.formulaRawProductVOList.length">
                    {{ text == null || text == '' ? text : text.toFixed(3) }}
                  </span>
                  <cell-editor v-else :len="3" :max="100" :min="0" :background="true" :item="record" name="percentage"
                    @blur="target => itemUpdate(target, 'percentage')" :text="text" />
                </template>
                <span slot="unit">KG</span>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="1" tab="营养分析">
              <a-table :pagination="false" :dataSource="nut" :row-key="record => record.id"
                :scroll="{ x: 0, y: 350 }" :columns="nutColumns">
                <template slot="content" slot-scope="text, record">
                  {{ text != null ? text.toFixed(record.unit === '' || record.unit === 'Kcal' ? 0 : 2) : text }}
                </template>
              </a-table>
            </a-tab-pane>
          </a-tabs>
          
          <!-- 额外添加原料 -->
          <div style="margin-top: 10px;">
            <h3>额外添加原料</h3>
            <a-row justify="space-between" type="flex" style="margin-bottom:10px">
              <a-space>
                <a-button type="primary" @click="addExtraMaterial">添加</a-button>
                <a-button type="danger" @click="deleteExtraMaterial" :disabled="!extraSelectedRowKeys.length > 0" ghost>删除</a-button>
              </a-space>
            </a-row>
            <a-table :columns="extraRawColumns" :pagination="false"
              :row-key="record => record.rawId"
              :row-selection="{ selectedRowKeys: extraSelectedRowKeys, onChange: onExtraSelectChange }"
              :dataSource="extraRaw">
              <span slot="uasge" slot-scope="text">
                {{ text == null || text == '' ? text : text.toFixed(3) }}
              </span>
              <template slot="percentage" slot-scope="text, record">
                <cell-editor :len="3" :max="100" :min="0" :background="true" :item="record" name="percentage"
                  @blur="target => extraItemUpdate(target, 'percentage')" :text="text" />
              </template>
              <span slot="unit">KG</span>
            </a-table>
          </div>

          <a-row class="footer" justify="space-between" align="middle" type="flex">
            <a-button @click="onClose">关闭</a-button>
            <a-button type="primary"
              :disabled="!raw.formulaRawProductVOList || raw.formulaRawProductVOList.length === 0"
              @click="ok">确定</a-button>
          </a-row>
        </a-form>
      </div>
    </a-spin>
    <raw-model :hidden="addVisible" @ok="insertRaw" @cancel="toggleAddVisible({})" />
    <extra-material-list :visible="addExtraVisible" @close="closeExtraMaterial" :ids="extraRawIds" />
    <PreviewModel :visible="previewNutritionVisible" @close="closePreviewNutrition"
      :materialList="raw.formulaRawProductVOList" :detail="detail" />
    <Replace-Model :hidden="replaceVisible" @ok="replaceRaw" @cancel="toggleReplaceVisible({})"
      :selectKeys="selectKeys" />
  </a-drawer>
</template>

<script>
import CellEditor from '../../Nhf/Compound/editor/CellEditor0.vue';
import RawModel from '../../Nhf/Compound/modal/RawModel.vue';
import PreviewModel from './PreviewModel.vue';
import ReplaceModel from './ReplaceModel.vue';
import { productMixins } from '../unitls';
import shixiao from '@/assets/images/shixiao.svg';
import ExtraMaterialList from '../../Nhf/Compound/modal/ExtraMaterialList.vue';

export default {
  components: { RawModel, CellEditor, PreviewModel, ReplaceModel, ExtraMaterialList },
  props: ['hidden'],
  mixins: [productMixins],
  computed: {
    prductName() {
      return this.detail.productName;
    },
    visibles() {
      return this.hidden ? true : false;
    },
    title() {
      return `复制产品${this.detail.productName}`;
    },
    selectKeys() {
      let lst = [];
      let { formulaRawProductVOList = [] } = this.raw || {};
      formulaRawProductVOList.forEach(el => {
        lst.push(el.rawId);
      });
      return lst;
    },
    preIsDisabled() {
      let { formulaRawProductVOList = [] } = this.raw || {};
      return formulaRawProductVOList.length === 0;
    },
    extraRawIds() {
      return this.extraRaw
        .filter(item => item.rawId !== 23000) // Exclude the summary row
        .map(item => item.rawId);
    }
  },

  data() {
    return {
      drawerWidth: 1200,
      replaceVisible: false,
      previewNutritionVisible: false,
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      form: this.$form.createForm(this),
      productName: '',
      copyLoading: false,
      addVisible: false,
      addExtraVisible: false,
      rawLoading: false,
      extraRawLoading: false,
      shixiaoSrc: shixiao,
      detail: { productName: '' },
      raw: {},
      nut: [],
      extraRaw: [],
      allExtraRaw: [],
      extraSelectedRowKeys: [],
      rawColumns: [
        {
          dataIndex: 'rawName',
          title: '原料名称',
          width: 220,
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.rawName.localeCompare(b.rawName, 'zh');
          },
          sortDirections: ['descend', 'ascend'],
          customRender: (text, row, index) => {
            let str = this.overseasFlag == '1' ? (row.aliasName || text) : text;
            if (index < this.raw.formulaRawProductVOList.length - 1) {
              if (row.status === 1) {
                return <div style="display: flex; positon: relative">
                  <img style="width: 26px; position: absolute; top: 0; left: 0"
                    src={this.shixiaoSrc} />
                  <span style="width: 22px"></span>
                  <span style="text-align: left">{str}</span>
                </div>;
              } else {
                return <span>{str}</span>;
              }
            }
            return {
              children:
                <span>{str}</span>,
              attrs: {
                colSpan: 2
              }
            };
          }
        },
        {
          dataIndex: 'rawCode',
          title: '原料代码',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.rawCode - b.rawCode;
          },
          sortDirections: ['descend', 'ascend'],
          align: 'center',
          customRender: this.renderContent
        },
        {
          dataIndex: 'percentage',
          title: '用量%',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.percentage - b.percentage;
          },
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'percentage' },
          align: 'center'
        },
        {
          dataIndex: 'uasge',
          title: '用量(批次量)',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.uasge - b.uasge;
          },
          scopedSlots: { customRender: 'uasge' },
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          dataIndex: 'unit',
          title: '单位',
          scopedSlots: { customRender: 'unit' },
          align: 'center',
          width: 50
        }
      ],
      nutColumns: [
        {
          dataIndex: 'name',
          title: '指标名称'
        },
        {
          dataIndex: 'fullName',
          title: '指标全称'
        },
        {
          dataIndex: 'content',
          title: '数值',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.content - b.content;
          },
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'content' },
          align: 'center'
        },
        {
          dataIndex: 'unit',
          title: '单位',
          width: 90
        }
      ],
      extraRawColumns: [
        {
          dataIndex: 'rawName',
          title: '原料名称',
          width: 220,
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.rawName.localeCompare(b.rawName, 'zh');
          },
          sortDirections: ['descend', 'ascend'],
          customRender: (text, row, index) => {
            let str = this.overseasFlag == '1' ? (row.aliasName || text) : text;
            if (index < this.extraRaw.length - 1) {
              if (row.status === 1) {
                return <div style="display: flex; positon: relative">
                  <img style="width: 26px; position: absolute; top: 0; left: 0"
                    src={this.shixiaoSrc} />
                  <span style="width: 22px"></span>
                  <span style="text-align: left">{str}</span>
                </div>;
              } else {
                return <span>{str}</span>;
              }
            }
            return {
              children:
                <span>{str}</span>,
              attrs: {
                colSpan: 2
              }
            };
          }
        },
        {
          dataIndex: 'rawCode',
          title: '原料代码',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.rawCode - b.rawCode;
          },
          sortDirections: ['descend', 'ascend'],
          align: 'center',
          customRender: this.renderExtraContent
        },
        {
          dataIndex: 'percentage',
          title: '用量%',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.percentage - b.percentage;
          },
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'percentage' },
          align: 'center'
        },
        {
          dataIndex: 'uasge',
          title: '用量(批次量)',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false;
            }
            return a.uasge - b.uasge;
          },
          scopedSlots: { customRender: 'uasge' },
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          dataIndex: 'unit',
          title: '单位',
          scopedSlots: { customRender: 'unit' },
          align: 'center',
          width: 50
        }
      ],
    };
  },
  watch: {
    visibles(val) {
      if (val) {
        this.selectedRowKeys = [];
        this.selectedRows = [];
        this.extraSelectedRowKeys = [];
        this.extraRaw = [];
        this.allExtraRaw = [];
      }
    },
    hidden(id) {
      if (id) {
        this.getDetail({ id });
        this.rawList({ id });
        this.nutList({ id });
        // Load extra raw materials
        this.getExtraRawList({ id });
      } else {
        this.raw = {};
        this.nut = {};
        this.extraRaw = [];
        this.allExtraRaw = [];
      }
    },
    raw(val) {
      if (val && val.formulaRawProductVOList) {
        this.getTotal(val.formulaRawProductVOList);
      }
    },
    extraRaw(val) {
      if (val && val.length > 0) {
        // Call any necessary additional methods when extraRaw changes
      }
    }
  },
  mounted() {
    const viewportWidth = window.innerWidth;
    const _width = viewportWidth * 0.8;
    if (_width < 1200) {
      this.drawerWidth = _width;
    }
  },
  methods: {
    checkboxProps(record) {
      return {
        props: {
          disabled: (this.selectedRowKeys.length >= this.maxLen && !this.selectedRowKeys.includes(record.rawId)) || record.rawName === '合计',
          name: record.rawName
        }
      };
    },
    renderContent(value, row, index) {
      const obj = {
        children: value,
        attrs: {}
      };
      if (index === this.raw.formulaRawProductVOList.length - 1) {
        obj.attrs.colSpan = 0;
      }
      return obj;
    },

    delectItem() {
      let list = [...this.raw.formulaRawProductVOList];
      this.selectedRowKeys.forEach(rawId => {
        list.splice(
          list.findIndex(item => item.rawId === rawId),
          1
        );
      });
      this.cleanSelect();
      this.raw.formulaRawProductVOList = list;
      this.getTotal();
    },

    itemUpdate(item, column) {
      let newData = [...this.raw.formulaRawProductVOList];
      let target = newData.filter(i => i.rawId === item.rawId)[0];
      if (target) {
        let value = item[column] ? Number(parseFloat(item[column]).toFixed(3)) : 0;
        target[column] = value;
        const uasge = value.div(100).mul(this.detail.totalWeight);
        Object.assign(target, item, { uasge });
        this.raw.formulaRawProductVOList = newData;
        this.getTotal();
      }
    },

    insertRaw(val) {
      const status = this.checkAddRaw(val);
      if (status) {
        const addList = val.map(i => {
          const { name, code } = i;
          return { ...i, uasge: null, percentage: null, rawName: name, rawCode: code };
        });
        this.toggleAddVisible();
        this.$nextTick(() => {
          let newList = this.raw.formulaRawProductVOList.length > 0 ? this.raw.formulaRawProductVOList.filter(el => el.rawId !== 23000) : [];
          this.getTotal([...addList, ...newList]);
        });
      } else {
        // this.$message.warn('不能添加重复原料')
        this.$error({
          title: '预览失败',
          content: '不能添加重复原料',
          okText: '知道了'
        });
      }
    },

    getTotal(arg) {
      this.$nextTick(() => {
        let all = arg || [...this.raw.formulaRawProductVOList].filter((item) => item.rawId !== 23000);
        this.allRaw = all;
        const allList = [
          ...all,
          {
            rawName: '合计',
            rawId: 23000,
            percentage: all.reduce((val, item) => val + (item.percentage === null || item.percentage === '' ? 0 : item.percentage > 0.001 ? Number(item.percentage.toFixed(3)) : item.percentage), 0),
            uasge: all.reduce((val, item) => val + (item.uasge === null || item.uasge === '' ? 0 : item.uasge > 0.001 ? Number(item.uasge.toFixed(3)) : item.uasge), 0)
          }
        ];
        this.raw.formulaRawProductVOList = all.length ? allList : [];
      });
    },
    checkAddRaw(list) {
      let flag = true;
      this.raw.formulaRawProductVOList.map(i => {
        const arr = list.filter(item => i.rawId === item.rawId);
        if (arr.length) flag = false;
      });
      return flag;
    },
    toggleAddVisible() {
      this.addVisible = !this.addVisible;
    },
    async ok() {
      let valid = await this.form.validateFields();
      if (!valid) {
        return false;
      }
      this.detail.productName = valid.productName;
      if (this.raw.formulaRawProductVOList.length) {
        let item = this.raw.formulaRawProductVOList[this.raw.formulaRawProductVOList.length - 1];
        if (item.percentage.toFixed('3') != "100.000") {
          this.$error({
            title: '预览失败',
            content: '当前配方原料用量合计不为100%',
            okText: '知道了'
          });
          return false;
        }
      }
      
      // Validate total extra materials don't exceed 5% of total weight
      if (this.allExtraRaw && this.allExtraRaw.length > 0) {
        // Filter out items with null or empty rawId (which might be added by mistake)
        this.allExtraRaw = this.allExtraRaw.filter(item => item.rawId && item.rawId !== 23000);
        
        // Check if any extra material has empty or zero quantity
        const hasEmptyOrZeroQuantity = this.allExtraRaw.some(item => {
          return item.percentage === null || item.percentage === undefined || item.percentage === 0 || item.percentage === '';
        });
        
        if (hasEmptyOrZeroQuantity) {
          this.$error({
            title: '操作失败',
            content: '额外添加原料用量必须>0,请调整后再提交。',
            okText: 'OK'
          });
          return false;
        }
        
        const totalExtraPercentage = this.allExtraRaw.reduce((total, item) => {
          return total + (item.percentage || 0);
        }, 0);
        
        if (totalExtraPercentage > 5) {
          this.$error({
            title: '操作失败',
            content: '额外添加原料总用量超过配方盘重的5%，请调整后再提交',
            okText: 'OK'
          });
          return false;
        }
      }
      
      await this.copyItem();
      this.$emit('ok');
    },
    async getDetail(data) {
      await this.fetchGet({
        name: 'detail',
        data,
        actions: this.formulaproductDetail,
        loading: 'detailLoading'
      });
    },
    onClose() {
      this.$emit('cancel');
    },
    async copyItem() {
      const formulaRawProductDTOList = this.allRaw.map(i => {
        const { rawId } = i;
        // Format percentage to 3 decimal places
        const percentage = i.percentage ? Number(parseFloat(i.percentage).toFixed(3)) : i.percentage;
        return { rawId, percentage };
      });
      
      // Add extra raw materials to the copy data
      const formulaRawExtraVOList = this.allExtraRaw && this.allExtraRaw.length > 0 ? 
        this.allExtraRaw.map(i => {
          const { rawId } = i;
          // Format percentage to 3 decimal places
          const percentage = i.percentage ? Number(parseFloat(i.percentage).toFixed(3)) : i.percentage;
          return { 
            rawId, 
            percentage,
            productId: i.productId || null
          };
        }) : [];
      
      const { productName, totalWeight, id: productId } = this.detail;
      await this.fetchPost({
        actions: this.copyFormulaProduct,
        loading: 'copyLoading',
        data: {
          formulaRawProductDTOList,
          formulaRawExtraVOList,
          productName,
          totalWeight,
          productId
        }
      });
    },
    async rawList({ id, ...arg }) {
      await this.fetchGet({
        name: 'raw',
        actions: this.selectFormulaProductRawByProductId2,
        loading: 'rawLoading',
        data: {
          productId: id,
          size: 1000,
          ...arg
        }
      });
    },
    async nutList({ id, ...arg }) {
      this.fetchGet({
        actions: this.selectFormulaProductNutritionByProductId,
        name: 'nut',
        data: {
          productId: id,
          size: 1000,
          ...arg
        }
      });
    },
    replaceRaw(rowData) {
      this.raw.formulaRawProductVOList.map((el) => {
        if (el.rawId === this.selectedRowKeys[0]) {
          el.rawName = rowData.name;
          el.rawCode = rowData.code;
          el.rawId = rowData.rawId;
        }
        return el;
      });
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.toggleReplaceVisible();
    },
    toggleReplaceVisible() {
      this.replaceVisible = !this.replaceVisible;
    },
    openPreviewNutrition() {
      // let check0 = this.raw.formulaRawProductVOList.some(e => !e.percentage && e.percentage !== 0)
      let check = this.raw.formulaRawProductVOList.every(e => !e.percentage);
      if (check) {
        this.$error({
          title: '预览失败',
          content: '请先设定原料用量比例，再进行预览',
          okText: '知道了'
        });
        return;
      }
      this.previewNutritionVisible = true;
    },
    closePreviewNutrition() {
      this.previewNutritionVisible = false;
    },
    addExtraMaterial() {
   
      if (this.extraRaw.length > 6) {
        this.$message.warning('额外添加原料最多能有5个原料');
        return;
      }
      this.addExtraVisible = true;
    },
    closeExtraMaterial(obj) {
      this.addExtraVisible = false;
      if (obj) {
        // Format the selected material to match the required structure
        const extraItem = {
          ...obj,
          rawId: obj.id,
          rawName: obj.name,
          rawCode: obj.code,
          percentage: '',
          uasge: '',
          unit: 'KG'
        };
        // Add to extraRaw list
        let newList = [...this.extraRaw].filter(el => el.rawId !== 23000);
        newList.push(extraItem);
        this.getExtraTotal(newList);
      }
    },
    deleteExtraMaterial() {
      let list = [...this.extraRaw];
      this.extraSelectedRowKeys.forEach(rawId => {
        list.splice(
          list.findIndex(item => item.rawId === rawId),
          1
        );
      });
      this.extraSelectedRowKeys = [];
      this.extraRaw = list;
      this.getExtraTotal();
    },
    onExtraSelectChange(selectedRowKeys) {
      this.extraSelectedRowKeys = selectedRowKeys;
    },
    extraItemUpdate(item, column) {
      let newData = [...this.extraRaw];
      let target = newData.filter(i => i.rawId === item.rawId)[0];
      if (target) {
        let value = item[column] ? Number(parseFloat(item[column]).toFixed(3)) : 0;
        target[column] = value;
        const uasge = value.div(100).mul(this.detail.totalWeight);
        
        // Calculate total percentage of all extra materials
        const totalExtraPercentage = newData
          .filter(material => material.rawId !== 23000 && material.rawId !== item.rawId) // Exclude the summary row and current item
          .reduce((total, material) => total + (material.percentage || 0), 0) + value;
        
        // Check if total usage exceeds 5%
        if (totalExtraPercentage > 5) {
          this.$error({
            title: '操作失败',
            content: '额外添加原料总用量超过配方盘重的5%，请调整后再提交',
            okText: 'OK'
          });
          // Reset to previous value
          target[column] = target[column] || 0;
          return;
        }
        
        Object.assign(target, item, { uasge });
        this.extraRaw = newData;
        this.getExtraTotal();
      }
    },
    insertExtraRaw(val) {
      const status = this.checkAddExtraRaw(val);
      if (status) {
        const addList = val.map(i => {
          const { name, code } = i;
          return { ...i, uasge: null, percentage: null, rawName: name, rawCode: code, rawId: i.id || i.rawId };
        });
        this.addExtraVisible = false;
        this.$nextTick(() => {
          let newList = this.extraRaw.length > 0 ? this.extraRaw.filter(el => el.rawId !== 23000) : [];
          
          // Ensure all items have required properties
          const combinedList = [...addList, ...newList].map(item => {
            return {
              ...item,
              rawId: item.rawId || item.id, // Ensure rawId is set
              percentage: item.percentage || null,
              uasge: item.uasge || null
            };
          });
          
          this.getExtraTotal(combinedList);
        });
      } else {
        this.$error({
          title: '添加失败',
          content: '不能添加重复原料',
          okText: '知道了'
        });
      }
    },
    getExtraTotal(arg) {
      this.$nextTick(() => {
        // Filter out items with invalid rawId and ensure we're working with valid data
        let all = arg || [...this.extraRaw].filter((item) => item.rawId !== 23000);
        
        // Filter out any potentially invalid items (no rawId)
        all = all.filter(item => item && item.rawId);
        
        this.allExtraRaw = all;
        const allList = [
          ...all,
          {
            rawName: '合计',
            rawId: 23000,
            percentage: all.reduce((val, item) => val + (item.percentage === null || item.percentage === '' ? 0 : item.percentage > 0.001 ? Number(item.percentage.toFixed(3)) : item.percentage), 0),
            uasge: all.reduce((val, item) => val + (item.uasge === null || item.uasge === '' ? 0 : item.uasge > 0.001 ? Number(item.uasge.toFixed(3)) : item.uasge), 0)
          }
        ];
        this.extraRaw = all.length ? allList : [];
      });
    },
    checkAddExtraRaw(list) {
      let flag = true;
      this.extraRaw.map(i => {
        const arr = list.filter(item => i.rawId === item.rawId);
        if (arr.length) flag = false;
      });
      return flag;
    },
    renderExtraContent(value, row, index) {
      const obj = {
        children: value,
        attrs: {}
      };
      if (index === this.extraRaw.length - 1) {
        obj.attrs.colSpan = 0;
      }
      return obj;
    },
    getExtraRawList({ id, ...arg }) {
      // Set loading state
      this.extraRawLoading = true;
      
      // Prepare request parameters
      const params = {
        productId: id,
        ...arg
      };
      console.log("Extra raw materials request params:", params);
      
      // Make the API call using promise-based approach
      this.$get('/nhf-app/formularawextraproduct/getFormulaRawExtraProductList', params)
        .then(response => {
          // Log the raw API response
          console.log("Raw API response for extra raw materials:", response);
          
          if (response && response.data && Array.isArray(response.data)) {
            // Format the data to match the expected structure
            const formattedData = response.data.map(item => ({
              rawId: item.rawId,
              rawName: item.rawName || item.name,
              rawCode: item.rawCode || item.code,
              percentage: item.percentage,
              uasge: item.percentage ? item.percentage.div(100).mul(this.detail.totalWeight) : 0,
              status: item.status,
              aliasName: item.aliasName
            }));
            
            console.log("this.formattedData..........", formattedData);
            this.extraRaw = formattedData;
            this.getExtraTotal(formattedData);
          } else {
            this.extraRaw = [];
            this.allExtraRaw = [];
          }
        })
        .catch(error => {
          console.error('Error fetching extra raw materials:', error);
          this.extraRaw = [];
          this.allExtraRaw = [];
        })
        .finally(() => {
          this.extraRawLoading = false;
        });
    },
  }
};
</script>
<style lang="scss" scoped>
.footer {
  height: 50px;
  margin: 0 -10px;
  padding: 0 10px;
  border-top: 1px solid #e8e8e8;
}
</style>
